import { useAtom } from 'jotai';
import { useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePopper } from 'react-popper';
import { useNavigate } from 'react-router-dom';
import { authAtom } from '../../atoms';
import { ApiClient } from '../../lib/api';
import { cln } from '../../lib/utils';
import { Avatar } from '../Avatar';
import { PATHS } from '../../lib/paths';
import { useOnClickOutside } from '../../hooks';

export function UserMenu() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [auth] = useAtom(authAtom);
  const apiClient = useMemo(() => new ApiClient(), []);
  const userMenuRef = useRef<HTMLDivElement>(null);

  const [triggerEl, setTriggerEl] = useState<HTMLButtonElement | null>(null);
  const [popperEl, setPopperEl] = useState<HTMLUListElement | null>(null);
  const { attributes, styles } = usePopper(triggerEl, popperEl, { placement: 'bottom-end' });

  useOnClickOutside(userMenuRef.current, () => setMenuOpen(false));

  const logout = async () => {
    await apiClient.logout();
    navigate('/login');
  };

  return (
    <div ref={userMenuRef}>
      <button
        ref={setTriggerEl}
        onClick={() => setMenuOpen((prev) => !prev)}
        className="p-0 rounded-full"
      >
        <Avatar seed={auth?.user?.name} />
      </button>
      <ul
        ref={setPopperEl}
        style={styles.popper}
        {...attributes.popper}
        className={cln(!isMenuOpen && 'hidden', 'bg-neutral-50 py-1 rounded shadow-xl z-20')}
      >
        <li>
          <button className="rounded-none w-full justify-start gap-4" onClick={logout}>
            <i className="ri-logout-box-r-line font-normal" onClick={logout} />
            {t('navigation.logout')}
          </button>
        </li>
        <li>
          <button
            className="rounded-none w-full justify-start gap-4"
            onClick={() => navigate(PATHS.settingsPath())}
          >
            <i
              className="ri-settings-3-line font-normal"
              onClick={() => navigate(PATHS.settingsPath())}
            />
            {t('navigation.settings')}
          </button>
        </li>
      </ul>
    </div>
  );
}
